import { Scroll, ScrollControls } from "@react-three/drei"

export default function Storytelling(props)
{  
    return <>
        <Scroll html style={{ width: '100%' }}>
            <div className="storytelling__text" style={{ top: `50vh` }}>
                <h2>Overall</h2>
                <hr></hr>
                <p>The Greenwood study site emanates WiFi to a mixed residential and light industrial area in this South Brooklyn neighborhood.
                </p>
            </div>

            <div className="storytelling__text" style={{ top: `150vh` }}>
                <h2>Site</h2>
                <hr></hr>
                <p>
                The site features a robust streetlife, primarily in the warmer months, that pulls in community members from the surrounding neighborhood to talk, eat, drink, and gather. 
                </p>
            </div>

            <div className="storytelling__text" style={{ top: `250vh`, opacity: 1}}>
                <h2>Music</h2>
                <hr></hr>
                <p>Some regulars use the LinkNYC free charging port to power portable speakers, and the free WiFi to connect devices to streaming services. Festive music, while certainly enjoyable to those gathered for that purpose, was described as a nuisance by local residents  and passersby. Perhaps specific hours of the day for music playing could be hammered out in collaboration with neighborhood groups. </p>
               </div>
            <div className="storytelling__text" style={{ top: `350vh` }}>
                <h2>Shade</h2>
                <hr></hr>
                <p>The LinkNYC kiosk here is located on the sunniest southern side of Fourth Avenue While some brave the heat of the summer, most of the users of the WiFi were tucked away in the shade. Greater guidelines or select programs to provide shade, similar to bus shelters, can enhance the LinkNYC experience. </p>
            </div>
            <div className="storytelling__text" style={{ top: `450vh` }}>
                <h2>Printing</h2>
                <hr></hr>
                <p>A couple of users here complained that when they tried to use the tablets or the WiFi for something useful, they could not print PDFs, open complicated files, or do other things that require a complete desktop to access. The nearest library is a shlep, a solid 15 minute walk up the street. LinkNYC kiosks  could be sited to intentionally relate symbiotically to other components of the public WiFi system. </p>
            </div>
            <div className="storytelling__text" style={{ top: `550vh` }}>
                <h2>STEM Classes</h2>
                <hr></hr>
                <p>In this community, the LinkNYC kiosk serves as a locus of streetlife. Given the limited traffic on 24th Street, there could be opportunities to utilize the emanating WiFi to invigorate SummerStreets initiatives or other open street ideas. LinkNYC can anchor community uses for the street that generate mini-plazas, parklets, or temporary public spaces. </p>
                </div>
            <div className="storytelling__end" style={{ top: `650vh` }}>
                <h2><a className="ending__links" href="https://lawrence-walkthrough.vercel.app/">Downtown Brooklyn</a></h2>
                <h2><a className="ending__links"  href="https://timessquare-walkthrough.vercel.app/">Times Square</a></h2>
                <h2><a className="ending__links"  href="https://harlem-walkthrough.vercel.app/">Harlem</a></h2>
            </div>
        </Scroll>
    </>

}